<template>
  <div>
    <div class="titleh1"><code />货源信息</div>
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="货源单号" prop="mainOrderNumber" min-width="300">
            <el-input
              ref="focus"
              v-model="form.mainOrderNumber"
              disabled
              placeholder="请输入货源单号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="货物名称" prop="coalTypeName">
            <el-input
              ref="focus1"
              v-model="form.coalTypeName"
              disabled
              placeholder="请输入货物名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="运费单价" prop="price">
            <el-input
              ref="focus2"
              v-model="form.price"
              disabled
              placeholder="请输入运费单价"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="剩余车数" prop="notReceivedCount">
            <el-input
              ref="focus3"
              v-model="form.notReceivedCount"
              disabled
              placeholder="请输入剩余车数"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="装货地址" prop="shipperAddress">
            <el-input
              ref="focus4"
              v-model="form.shipperAddress"
              disabled
              placeholder="请输入装货地址"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="卸货地址" prop="consigneeAddress">
            <el-input
              ref="focus5"
              v-model="form.consigneeAddress"
              disabled
              placeholder="请输入卸货地址"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="selectSource">
            <el-button type="primary" @click="Shipperlist()">
              选择货源
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="titleh1"><code />承运车辆</div>
      <el-row>
        <el-col :span="6">
          <el-form-item label="车牌号" prop="vehicleLicense">
            <el-input
              v-model="form.vehicleLicense"
              disabled
              placeholder="请输入车牌号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="运输许可号">
            <el-input
              v-model="form.roadTransportCertificateNumber"
              disabled
              placeholder="请输入运输许可号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车辆载重(kg)">
            <el-input
              v-model="form.vehicleLoadWeight"
              disabled
              placeholder="请输入车辆载重"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="实际承运人姓名">
            <el-input
              v-model="form.driverName"
              disabled
              placeholder="请输入实际承运人姓名"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item prop="selectVehicle">
            <el-button type="primary" @click="designatedDriver()">
              选择车辆
            </el-button>
          </el-form-item>
        </el-col>
        <el-col v-if="form.driverType == 0 && inTeam" :span="6">
          <el-form-item label="接单类型" prop="receiveType">
            <el-radio-group v-model="form.receiveType">
              <el-radio :label="1"> 独立实际承运人接单 </el-radio>
              <el-button
                style="border:none;"
                @click="designatedDriverTeamList()"
              >
                <el-radio :label="2">
                  车队接单
                </el-radio>
              </el-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col
          v-if="form.receiveType == 2 && form.driverType == 0 && inTeam"
          :span="6"
        >
          <el-form-item
            label="结算车队"
            prop="teamCode"
            :rules="
              form.receiveType == 2 ? rules.teamCode : [{ required: true }]
            "
          >
            <el-input
              v-model="form.teamCode"
              disabled
              placeholder="请输入结算车队"
              style="display:none"
            />
            <el-input
              v-model="form.linkMan"
              disabled
              placeholder="请输入结算车队"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <div class="titleh1"><code />运单信息</div>
      <el-row>
        <el-col :span="6">
          <el-form-item label="接单时间" prop="gmtCreated">
            <div class="block">
              <el-date-picker
                v-model="form.gmtCreated"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择日期时间"
              />
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="装车时间" prop="fillTime">
            <div class="block">
              <el-date-picker
                v-model="form.fillTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择日期时间"
              />
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="卸车时间" prop="signTime">
            <div class="block">
              <el-date-picker
                v-model="form.signTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择日期时间"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="装车重量" prop="loadWeight">
            <el-input
              v-model="form.loadWeight"
              placeholder="请输入装车重量"
              @input="
                value =>
                  formFormatter.isFloor3(value, oldValue, form, 'loadWeight')
              "
            >
              <i slot="suffix">吨</i>
            </el-input>
          </el-form-item>
          <el-form-item prop="loadImgUrl">
            <ImgUpload
              :upload-config="{
                lebal: '装货单据',
                prefix: 'loadImgUrl',
                form: form,
                suffix: ''
              }"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="卸车重量" prop="unloadWeight">
            <el-input
              v-model="form.unloadWeight"
              placeholder="请输入卸车重量"
              @input="
                value =>
                  formFormatter.isFloor3(value, oldValue, form, 'unloadWeight')
              "
            >
              <i slot="suffix">吨</i>
            </el-input>
          </el-form-item>
          <el-form-item prop="ticketImageUrl">
            <ImgUpload
              :upload-config="{
                lebal: '卸货单据',
                prefix: 'ticketImageUrl',
                form: form,
                suffix: ''
              }"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button
          v-if="supplement_affirm_button"
          type="primary"
          @click="submitForm('form')"
        >
          确定
        </el-button>
      </el-form-item>
    </el-form>

    <vxe-modal
      v-model="tuteship"
      title="选择货源"
      width="1000"
      height="80%"
      resize
    >
      <customer ref="ShipperlRef" @event1="receive" />
    </vxe-modal>
    <vxe-modal
      v-model="zhidingsiji"
      title="选择车辆"
      width="1000"
      height="85%"
      resize
    >
      <Designated ref="Driver" @event2="receive2" />
    </vxe-modal>
    <vxe-modal
      v-model="zhidingchedui"
      title="选择车队"
      width="1000"
      height="85%"
      resize
    >
      <DriverTeamList ref="DriverTeamList" @event3="receive3" />
    </vxe-modal>
  </div>
</template>
<script>
import { getLimit } from "@/utils/getLimit.js";
import { extraAddOrderDetail } from "@/api/transport";
import { IsDriverInTeam } from "@/api/driver";
import customer from "./components/customer.vue";
import Designated from "./components/Designated.vue";
import DriverTeamList from "./components/DriverTeamList.vue";
import ImgUpload from "@/components/ImgUpload";
export default {
  components: {
    customer,
    Designated,
    DriverTeamList,
    ImgUpload
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          areaOptions: [],
          vehicleTypeAllowList: [],
          vehicleClassificationList: [],
          vehicleLengthList: [],
          vehicleWidthList: [],
          vehicleHighList: [],
          vehicleTonnageList: [],
          vehicleLicenseColorList: [],
          vehicleEnergyTypeList: []
        };
      }
    }
  },
  data() {
    return {
      tuteship: false,
      zhidingsiji: false,
      zhidingchedui: false,
      hasShipper: false,
      form: {
        mainOrderNumber: "",
        coalTypeName: "",
        price: "",
        notReceivedCount: "",
        shipperAddress: "",
        consigneeAddress: "",
        vehicleLicense: "",
        roadTransportCertificateNumber: "",
        vehicleLoadWeight: "",
        driverName: "",
        fillTime: "",
        signTime: "",
        unloadWeight: "",
        loadWeight: "",
        loadImgUrl: "",
        ticketImageUrl: "",
        selectSource: "",
        selectVehicle: "",
        branchCode: "",
        partyCode: "",
        receiveType: 1,
        teamCode: "",
        driverType: ""
      },
      dialogVisible: false,
      supplement_affirm_button: false, //确认
      dialogImageUrl: "",
      rules: {
        // mainOrderNumber: [
        //   { required: true, message: "请输入货源单号", trigger: "blur" }
        // ],
        // coalTypeName: [
        //   { required: true, message: "请输入货物名称", trigger: "blur" }
        // ],
        // price: [{ required: true, message: "请输入运费单价", trigger: "blur" }],
        // notReceivedCount: [
        //   { required: true, message: "请输入剩余车数", trigger: "blur" }
        // ],
        // shipperAddress: [
        //   { required: true, message: "请输入装货地址", trigger: "blur" }
        // ],
        // consigneeAddress: [
        //   { required: true, message: "请输入卸货地址", trigger: "blur" }
        // ],
        teamCode: [
          { required: true, message: "请选择结算车队", trigger: "change" }
        ],
        selectSource: [
          { required: true, message: "请选择货源", trigger: "change" }
        ],
        selectVehicle: [
          { required: true, message: "请选择车辆", trigger: "change" }
        ],
        loadWeight: [
          { required: true, message: "请输入装车重量", trigger: "blur" },
          { min: 0, max: 20, message: "长度不超过20个字符", trigger: "blur" }
        ],
        unloadWeight: [
          { required: true, message: "请输入卸车重量", trigger: "blur" },
          { min: 0, max: 20, message: "长度不超过20个字符", trigger: "blur" }
        ],
        gmtCreated: [
          {
            type: "string",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ],
        fillTime: [
          {
            type: "string",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ],
        signTime: [
          {
            type: "string",
            required: true,
            message: "请选择时间",
            trigger: "change"
          }
        ]
      },
      inTeam: false
    };
  },
  mounted() {},
  created() {
    this.supplement_affirm_button = getLimit("supplement_affirm_button");
  },
  methods: {
    submitForm(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          let start = new Date(this.form.fillTime);
          let end = new Date(this.form.signTime);
          let gmtCreated = new Date(this.form.gmtCreated);
          if (start >= end) {
            this.$message({
              message: "装车时间必须小于卸车时间！",
              type: "error"
            });
            return false;
          }
          if (gmtCreated >= start) {
            this.$message({
              message: "接单时间必须小于装车时间！",
              type: "error"
            });
            return false;
          }
          const rLoading = this.openLoading();
          extraAddOrderDetail(this.form).then(response => {
            rLoading.close();
            this.$message({
              message: response.msg,
              type: "success"
            });
          });
        } else {
          return false;
        }
      });
    },
    // 选择货源
    Shipperlist() {
      this.$refs.ShipperlRef.shipmentlist();
      this.tuteship = true;
    },

    // 选择车辆
    designatedDriver() {
      if (!this.hasShipper) {
        return this.$message.warning("请选择托运人");
      }
      this.$refs.Driver.designcar(this.form.branchCode);
      this.form.receiveType = 1;
      this.zhidingsiji = true;
      this.inTeam = false;
    },
    // 选择车队
    designatedDriverTeamList() {
      this.form.teamCode = "";
      this.$refs.DriverTeamList.designcar(
        this.form.branchCode,
        this.form.partyCode
      );
      this.zhidingchedui = true;
    },
    // 选择货源子组件向父组件传值
    receive(data) {
      this.hasShipper = true;
      this.form.mainOrderNumber = data.mainOrderNumber;
      this.form.coalTypeName = data.coalTypeName;
      this.form.price = data.price;
      this.form.notReceivedCount = data.notReceivedCount;
      this.form.coalTypeName = data.coalTypeName;
      this.form.shipperAddress = data.shipperAddress;
      this.form.consigneeAddress = data.consigneeAddress;
      this.form.branchCode = data.branchCode;
      this.form.selectSource = "1";
      this.$refs.form.clearValidate("selectSource");
      // /price  notReceivedCount  consigneeAddress  shipperAddress
      this.tuteship = false;
      this.$refs.focus.focus();
      this.$refs.focus1.focus();
      this.$refs.focus2.focus();
      this.$refs.focus3.focus();
      this.$refs.focus4.focus();
      this.$refs.focus5.focus();
    },

    // 选择车辆子组件向父组件传值
    receive2(data) {
      const rLoading = this.openLoading();
      this.form.receiveType = 1;
      this.form.teamCode = "";
      this.form.vehicleLicense = data.licenseNumber;
      this.form.roadTransportCertificateNumber =
        data.roadTransportCertificateNumber;
      this.form.driverName = data.driverName;
      this.form.vehicleLoadWeight = data.loadWeight;
      this.form.driverType = data.driverType;
      this.form.partyCode = data.partyCode;
      this.form.selectVehicle = "1";
      this.$refs.form.clearValidate("selectVehicle");
      this.zhidingsiji = false;
      IsDriverInTeam({
        branchCodeExt: this.form.branchCode,
        partyCode: data.partyCode
      }).then(response => {
        rLoading.close();
        if (response.status == 0) {
          this.inTeam = response.data;
        }
      });
    },
    receive3(data) {
      this.form.linkMan = data.linkMan;
      this.form.teamCode = data.partyCode;
      if (this.form.teamCode == "") {
        this.form.receiveType = 1;
      }
      this.zhidingchedui = false;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    ShippingDocuments(response, file, fileList) {
      this.form.loadImgUrl = response.data;
    },
    UnloadingDocuments(response, file, fileList) {
      this.form.ticketImageUrl = response.data;
    }
  }
};
</script>

<style lang="scss" scoped>
.el-date-editor.el-input {
  width: 100%;
}
.titleh1 {
  line-height: 50px;
  border-bottom: 1px solid #e2e2e2;
  margin-bottom: 15px;
  code {
    width: 5px;
    height: 20px;
    background-color: #ff7f21;
    float: left;
    margin-right: 5px;
    margin-top: 13px;
  }
}
.el-autocomplete {
  width: 81%;
}
</style>
